<template>
    <ResourceInput
        label="Body"
        attribute="body"
        type="richtext"
    />
</template>
